import { GlobalState } from '../index';

export const selectRatingSravni = (state: GlobalState) => state.ratings.ratingSravni;
export const selectServicesRating = (state: GlobalState) => state.ratings.servicesRating;
export const selectProductsRating = (id: string) => (state: GlobalState) => state.ratings.productsRating[id];
